// extracted by mini-css-extract-plugin
export default {"container":"SearchInput_container__LyZnt","searchInput":"SearchInput_searchInput__R0ZmS"};